module.exports = __webpack_public_path__ + "img/icon3.e333118a.gif";